import type { ItemValidationResultEntity } from './ItemValidationResultEntity'
import type { ValidationSummaryEntity } from './ValidationSummaryEntity'

export class CheckExternalBranchApiEntity {
  isValid?: boolean
  totalItemsReported?: number
  itemsChecked?: number
  globalIssues?: Array<string> | null
  itemResults?: Array<ItemValidationResultEntity> | null
  summary?: ValidationSummaryEntity
}
